import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import ButtonGroup from 'react/components/ButtonGroup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import {
  zoomInIcon,
  zoomInIconActive,
  editIcon,
  editIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';
import ZonesButton from './ZonesButton.jsx';
import HeatMapsButton from './HeatMapsButton.jsx';
import SignatureHeatMapButton from './SignatureHeatMapButton.jsx';
import SignatureLocationButton from './SignatureLocationButton.jsx';
import SignatureAccuracyButton from './SignatureAccuracyButton.jsx';
import ArrivalHeatMapButton from './ArrivalHeatMapButton.jsx';
import ArrivalLocationButton from './ArrivalLocationButton.jsx';
import ArrivalAccuracyButton from './ArrivalAccuracyButton.jsx';
import DepartureLocationButton from './DepartureLocationButton.jsx';
import GeocodeButton from './GeocodeButton.jsx';
import { activeBackgroundIconColor, secondaryBackgroundColor, fontFamily } from '../colorsAndFonts.js';
import { checkPermissions } from 'react/utils/utils';

const buttonWithIconStyle = {
  base: {
    minWidth: '50px',
    minHeight: '70px',
    padding: '0 5px'
  },
  label: {
    fontFamily,
    marginTop: '5px',
    fontSize: '.9em',
    lineHeight: '1.2'
  },
  icon: {
    width: '32px',
    height: '32px',
    backgroundSize: '20px',
    backgroundRepeat: 'no-repeat'
  }
};

const buttonWidthDropdownStyle = {
  ...buttonWithIconStyle,
  dropdown: {
    border: '1px solid #d0d7dd',
    minWidth: '170px',
    backgroundColor: secondaryBackgroundColor,
    borderRadius: '8px',
    zIndex: '100',
    boxShadow: '0px 0px 18px rgba(0, 0, 0, .16)'
  }
};

class ActionButtons extends Component {
  zoomIn = () => {
    const { map, marker } = this.props;
    const latLng = marker.getLatLng();
    map.setView(latLng, 18);
  };

  openEditStop = () => {
    const { pushAction, locationId } = this.props;
    const url = `/Location/edit/${locationId}`;
    pushAction(url);
  };

  render() {
    const {
      routeId,
      stopId,
      hasGeocodeCreatePermission,
      hasGeocodeListPermission,
      hasEditLocationPermission
    } = this.props;

    const hasGeocodingPermissions =
      hasGeocodeCreatePermission &&
      hasGeocodeListPermission &&
      checkPermissions('ROUTEDETAIL_GEOCODE');

    return (
      <ButtonGroup id="stop-details-action-buttons">
        <ButtonWithIcon
          styles={buttonWithIconStyle}
          label={Monet.I18n.getResourcesByKey(
            'routeDetails.stopDetailsPopup.zoomInStopButton'
          )}
          iconUrl={zoomInIcon}
          activeIconUrl={zoomInIconActive}
          activeBackground={activeBackgroundIconColor}
          onClick={this.zoomIn}
          changeOnlySelected={true}
        />
        <ZonesButton
          routeId={routeId}
          stopId={stopId}
          styles={buttonWidthDropdownStyle}
          changeOnlySelected={true}
          activeBackground="#cbcbcb"
          dropdown={
            <ButtonGroup>
              <SignatureLocationButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
              <SignatureAccuracyButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
              <ArrivalLocationButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
              <ArrivalAccuracyButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
              <DepartureLocationButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
            </ButtonGroup>
          }
        />
        <HeatMapsButton
          routeId={routeId}
          stopId={stopId}
          styles={buttonWidthDropdownStyle}
          changeOnlySelected={true}
          activeBackground={activeBackgroundIconColor}
          dropdown={
            <ButtonGroup>
              <SignatureHeatMapButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
              <ArrivalHeatMapButton
                routeId={routeId}
                stopId={stopId}
                styles={buttonWithIconStyle}
              />
            </ButtonGroup>
          }
        />
        {hasGeocodingPermissions && (
          <GeocodeButton
            routeId={routeId}
            stopId={stopId}
            styles={buttonWithIconStyle}
            changeOnlySelected={true}
            activeBackground={activeBackgroundIconColor}
          />
        )}
        {hasEditLocationPermission && (
          <ButtonWithIcon
            styles={buttonWithIconStyle}
            label={Monet.I18n.getResourcesByKey(
              'routeDetails.stopDetailsPopup.editStopButton'
            )}
            iconUrl={editIcon}
            activeIconUrl={editIconActive}
            onClick={this.openEditStop}
            changeOnlySelected={true}
            activeBackground={activeBackgroundIconColor}
          />
        )}
      </ButtonGroup>
    );
  }
}

ActionButtons.propTypes = {
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marker: PropTypes.object.isRequired,
  map: PropTypes.object.isRequired,
  pushAction: PropTypes.func.isRequired,
  hasGeocodeCreatePermission: PropTypes.bool.isRequired,
  hasGeocodeListPermission: PropTypes.bool.isRequired,
  hasEditLocationPermission: PropTypes.bool.isRequired
};

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  locationId: stopDetailsPopup.getIn([
    String(routeId),
    String(stopId),
    'stop',
    'location',
    'id'
  ])
});

const mapDispatchToProps = (dispatch) => ({
  pushAction: bindActionCreators(push, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionButtons);
